module.exports = __webpack_public_path__ + "static/media/在线围棋.622a3d5e.png";